/* Mystery discount popup: tease → email → reveal. Shown once; a dismissal is remembered for 7 days. */
(() => {
  const dialog = document.querySelector('[data-offer]');
  if (!dialog) return;
  const KEY = 'club-offer';
  let saved = {};
  try { saved = JSON.parse(localStorage.getItem(KEY)) || {}; } catch { /* storage blocked: show once per page view */ }
  const save = state => { try { localStorage.setItem(KEY, JSON.stringify({ state, at: Date.now() })); } catch { /* ignore */ } };
  if (saved.state === 'revealed' || (saved.state === 'dismissed' && Date.now() - saved.at < 7 * 864e5)) return;

  const root = document.body.dataset.root || '/';
  const { code, label } = dialog.dataset;
  const title = dialog.querySelector('[data-offer-title]');
  const form = dialog.querySelector('form');
  const email = dialog.querySelector('#OfferEmail');
  const error = dialog.querySelector('[data-offer-error]');
  const show = step => {
    dialog.dataset.step = step;
    dialog.querySelectorAll('[data-offer-pane]').forEach(pane => pane.hidden = pane.dataset.offerPane !== step);
  };
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Slide change: the current pane lifts out, the sheet eases to its new height, the next pane rises in (CSS).
  async function go(step, change) {
    const from = dialog.querySelector('[data-offer-pane]:not([hidden])');
    if (!reduce) await from.animate({ opacity: [1, 0], transform: ['none', 'translateY(-10px)'] }, { duration: 160, easing: 'ease-in', fill: 'forwards' }).finished.catch(() => {});
    const before = dialog.offsetHeight;
    change?.();
    show(step);
    if (!reduce) dialog.animate({ height: [before + 'px', dialog.offsetHeight + 'px'] }, { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)' });
  }
  // The mystery box shuffles letters, then locks the code in one character at a time.
  function decode(box) {
    const done = () => { box.textContent = code; box.removeAttribute('aria-hidden'); confetti(); };
    if (reduce) return done();
    const pool = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', frames = 20;
    let frame = 0;
    const tick = () => {
      frame++;
      if (frame >= frames) return done();
      box.textContent = [...code].map((char, i) => i < frame / frames * code.length ? char : pool[Math.random() * pool.length | 0]).join('');
      setTimeout(tick, 45);
    };
    tick();
  }
  function confetti() {
    if (reduce) return;
    const host = dialog.querySelector('[data-offer-confetti]');
    const colours = ['var(--blunder-red)', 'var(--ink-line)', 'var(--garment-sand)', 'var(--garment-heather)'];
    for (let i = 0; i < 70; i++) {
      const bit = document.createElement('i');
      bit.style.cssText = `left:${Math.random() * 100}%;background:${colours[i % 4]};animation-delay:${Math.random() * .5}s;animation-duration:${1.6 + Math.random() * 1.4}s;--drift:${(Math.random() - .5) * 180}px;--spin:${Math.random() * 720 - 360}deg`;
      host.append(bit);
    }
    setTimeout(() => host.replaceChildren(), 4000);
  }

  dialog.querySelector('[data-offer-next]').addEventListener('click', () => go('email').then(() => email.focus({ preventScroll: true })));
  form.addEventListener('submit', event => {
    event.preventDefault();
    error.hidden = email.checkValidity();
    if (!email.checkValidity()) { email.focus(); return; }
    // Subscribe and apply the code in the background; the reveal never waits on the network.
    fetch(form.action, { method: 'POST', body: new FormData(form) }).catch(() => {});
    // Tell Omnisend who this visitor is straight away, so browse and cart tracking attach to the new contact.
    try { window.omnisend?.identifyContact?.({ email: email.value }); } catch { /* Omnisend not loaded */ }
    fetch(`${root}discount/${encodeURIComponent(code)}`).catch(() => {});
    save('revealed');
    go('done', () => { title.textContent = label; }).then(() => { title.focus({ preventScroll: true }); decode(dialog.querySelector('[data-offer-code]')); });
  });
  dialog.querySelector('[data-offer-copy]').addEventListener('click', event => {
    navigator.clipboard?.writeText(code).then(() => { event.target.textContent = 'Copied'; }).catch(() => {});
  });
  dialog.addEventListener('close', () => { if (dialog.dataset.step !== 'done') save('dismissed'); });
  setTimeout(() => { if (!document.querySelector('dialog[open]')) dialog.showModal(); }, Number(dialog.dataset.delay || 6) * 1000);
})();
